var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Inject } from '../di/inject';
import { Injectable } from '../di/injectable';
import { DOMUtils } from './dom/index';
var Api = /** @class */ (function () {
    function Api() {
    }
    Object.defineProperty(Api.prototype, "pbContext", {
        get: function () {
            var _a;
            return (_a = this.domUtils.getElement('[name=pbContext]', document.head)) === null || _a === void 0 ? void 0 : _a.getAttribute('content');
        },
        enumerable: false,
        configurable: true
    });
    Api.prototype.widgetId = function (widget) {
        var _a, _b;
        return (_b = (_a = widget.getAttribute('widget-id')) !== null && _a !== void 0 ? _a : widget.dataset.widgetId) !== null && _b !== void 0 ? _b : widget.id;
    };
    /**
     * Request an updated HTML for the widget by using the context
     *
     * @param widget
     * @param url
     * @param method
     * @param dataType
     * @param data
     * @returns
     */
    Api.prototype.renderWidget = function (widget, name, incoming, method, dataType) {
        if (incoming === void 0) { incoming = {}; }
        if (method === void 0) { method = "GET"; }
        if (dataType === void 0) { dataType = 'html'; }
        return __awaiter(this, void 0, void 0, function () {
            var data, widgetId, pbContext, searchParams;
            return __generator(this, function (_a) {
                data = incoming;
                if (widget) {
                    widgetId = this.widgetId(widget);
                    pbContext = this.pbContext;
                    if (!(widgetId === null || widgetId === void 0 ? void 0 : widgetId.length)) {
                        throw new Error('Widget ID not found');
                    }
                    if (!(pbContext === null || pbContext === void 0 ? void 0 : pbContext.length)) {
                        throw new Error('PB Context not found');
                    }
                    data['pbContext'] = this.pbContext;
                    data['widgetId'] = widgetId;
                }
                searchParams = new URL(window.location.href).searchParams;
                if (searchParams.has("showJson")) {
                    data["showJson"] = searchParams.get("showJson");
                }
                return [2 /*return*/, this.fetch("/pb/widgets/".concat(name), method, dataType, data)];
            });
        });
    };
    /**
     * Converts the data to query string which could be appended to the url
     *
     * @param data
     * @returns string
     */
    Api.prototype.dataToQueryString = function (data, url) {
        var params;
        var hasParams = (url || "").indexOf('?') > -1;
        var updatedData = [];
        for (var key in data) {
            updatedData.push("".concat(key, "=").concat(encodeURIComponent("".concat(data[key]))));
        }
        params = updatedData.join('&');
        return hasParams ? "&".concat(params) : "?".concat(params);
    };
    /**
     * Sends the request to the server, instead of nativally using fetch use this method
     *
     * @param url
     * @param method
     * @param dataType
     * @param data
     *
     * @returns Promise<RequestResponse>
     */
    Api.prototype.fetch = function (url, method, dataType, data) {
        if (method === void 0) { method = "GET"; }
        if (dataType === void 0) { dataType = 'html'; }
        if (data === void 0) { data = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var hasRequestBody, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hasRequestBody = method === "POST" || method === "PUT" || method === "PATCH";
                        if (!hasRequestBody) {
                            url = url + this.dataToQueryString(data, url);
                        }
                        return [4 /*yield*/, fetch(url, {
                                method: method,
                                headers: this.getHeaderFromData(data),
                                body: hasRequestBody ? this.serialize(data) : null,
                            })];
                    case 1:
                        response = _a.sent();
                        if (response.status === 404) {
                            throw new Error('not found');
                        }
                        if (response.status === 500) {
                            throw new Error('internal server error');
                        }
                        return [2 /*return*/, dataType == 'json' || dataType == 'jsonp' ? response.json() : response.text()];
                }
            });
        });
    };
    Api.prototype.serialize = function (incomingData) {
        var data = '';
        if (incomingData instanceof FormData) {
            var updatedData_1 = [];
            incomingData.forEach(function (value, key) {
                updatedData_1.push("".concat(key, "=").concat(encodeURIComponent("".concat(value))));
            });
            data = updatedData_1.join('&');
        }
        else {
            data = JSON.stringify(incomingData);
        }
        return data;
    };
    Api.prototype.getHeaderFromData = function (data) {
        return data instanceof FormData ? { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' } : { 'Content-Type': 'application/json' };
    };
    Api.prototype.get = function (url, data, type) {
        if (data === void 0) { data = {}; }
        if (type === void 0) { type = 'json'; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetch(url, 'GET', type, data)];
            });
        });
    };
    Api.prototype.post = function (url, data, type) {
        if (data === void 0) { data = {}; }
        if (type === void 0) { type = 'json'; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetch(url, 'POST', type, data)];
            });
        });
    };
    __decorate([
        Inject(),
        __metadata("design:type", DOMUtils)
    ], Api.prototype, "domUtils", void 0);
    Api = __decorate([
        Injectable()
    ], Api);
    return Api;
}());
export { Api };
//# sourceMappingURL=api.js.map